import { createContext } from "react";
import type useGroupIdentityById from "src/hooks/data/load/useGroupIdentityById";

export interface IGroupIdentityContext extends ReturnType<typeof useGroupIdentityById> {}

export const GroupIdentityContext = createContext<IGroupIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default GroupIdentityContext;
